<template>
    <div style="background: #FAFAFA;">
        <div>
            <!-- Modal -->
            <div class="modal fade" id="verification" tabindex="-1" aria-labelledby="verification" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title title-modal" id="verification">NIN Verification</h5>
                            <button @click="showDetails = false; nin = ''; ninData = ''" type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-4 container" style="background: #FAFAFA;">
                            <div class="form-group">
                                <label for="nin">National Identification Number (NIN)</label>
                                <input v-model="nin" type="number" class="form-control inputt" id="nin" placeholder="Enter NIN">
                            </div>

                            <div class="verification-holder mt-5" v-if="showDetails === true && nin != ''">
                                <div class="form-group verification-list">
                                    <h4>ID Type</h4>
                                    <h3>NIN</h3>
                                </div>
                                <div class="form-group verification-list">
                                    <h4>Full Name</h4>
                                    <h3>{{ ninData.data.firstname }} {{ ninData.data.surname }}</h3>
                                </div>
                                <div class="form-group verification-list">
                                    <h4>ID Number</h4>
                                    <h3>{{ninData.data.nin}}</h3>
                                </div><div class="form-group verification-list">
                                    <h4>Date of Birth</h4>
                                    <h3>{{ ninData.data.birthdate }}</h3>
                                </div>
                                <div class="form-group verification-list">
                                    <h4>Gender</h4>
                                    <h3>{{ninData.data.gender == 'f' ? 'Female' : 'Male'}}</h3>
                                </div>
                            </div>
                        </div>

                       
            
                        <div class="form-group save-btn container">
                            <button class="btn" @click="verifyNIN()" :disabled="ninVerify" v-if="!showDetails">
                                Verify
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="ninVerify"
                                    >
                                </i>
                            </button>
                            <button class="btn" v-if="showDetails" :disabled="ninVerify" @click="submitNIN()">
                                Submit
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="ninVerify"
                                    >
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "Verification",
    components: {
        PageLoader
    },

    data() {
        return {
            ninVerify: false,
            showDetails: false,
            nin: "",
            ninData: '',
            kid_id: null
        };
    },
    watch: {
        nin(newVal, oldVal) {
            if (newVal == '') {
                this.showDetails = false;
            }
        }
    },
    created() {
        const kidItem = JSON.parse(localStorage.getItem('kidDetails'));
        if (kidItem) {
            this.kid_id = kidItem.id;
        }
    },
    mounted() {
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        async verifyNIN() {
            if (this.nin == '') {
                return this.$store.commit("setApiFailed", "Enter NIN number");
            }
            this.ninVerify = true;
            try {
                await Api.postRequest('fetch-nin-details', {nin: this.nin}).then(res => {
                    this.ninVerify = false;
                    if (res.data.success) {
                        if (res.data.data) {
                            console.log('helloe')
                            this.showDetails = true;
                        }
                        this.ninData = res.data.data;
                    }
                }).catch (err => {
                    console.log("Error:", err);
                    this.ninVerify = false;
                })
            } finally {
                this.ninVerify = false;
                // console.log("closed")
            }
        },
        async submitNIN() {
            if (this.nin == '') {
                return this.$store.commit("setApiFailed", "Enter NIN number");
            }
            this.ninVerify = true;
            try {
                await Api.postRequest('update-kid-after-nin-verification', {
                    firstname: this.ninData.data.firstname,
                    lastname: this.ninData.data.surname,
                    gender: this.ninData.data.gender,
                    date_of_birth: this.ninData.data.birthdate,
                    kid_id: this.kid_id
                }).then(res => {
                    this.ninVerify = false;
                    if (res.data.success) {
                        $("#verification")
                            .removeClass("fade")
                            .modal("hide");
                            location.reload(); 
                        return this.$store.commit("setApiSuccess", "Success");
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch (err => {
                    console.log("Error:", err);
                    this.ninVerify = false;
                })
            } finally {
                this.ninVerify = false;
                // console.log("closed")
            }
        }
    }
};
</script>

<style scoped lang="scss">
.title-modal {
    font-family: Nunito;
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    color: #1C2B3A;
}
label {
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #5D6F7C;
    display: flex;
}
.inputt {
    height: 48px;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e8e9e9;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #A3A3A3;
    outline: 0;
    box-shadow: none;

}
.verification-holder {
    background: #ffffff;
    border-radius: 20px;
    padding: 10px 15px 0;
    .verification-list {
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #F5F7FA;
        padding: 5px 10px;
        h4 {
            font-family: Lato;
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            color: #5D6F7C;
            text-align: left;
        }
        h3 {
            font-family: Lato;
            font-weight: 600;
            font-size: 16px;
            text-align: right;
            line-height: 24px;
            color: #1C2B3A;

        }
    }
}

.save-btn {
    margin-top: 10px;
    margin-bottom: 20px;
    button {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
}
</style>